import React, { useState, useEffect } from "react";
import API_DOMAIN from "../config/config";
import {
  Container,
  Nav,
  Navbar,
  Col,
  Row,
  Offcanvas,
  Button,
  Modal,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Buttons, ClickButton } from "../components/Buttons";
import { PDFDownloadLink, pdf } from "@react-pdf/renderer";
import { TableUI } from "../components/Tables";
import { PageHead, PageTitle } from "../components/PageTitle";
import { MdOutlineClose } from "react-icons/md";
import EstimationPdf from "./EstimationPdf";
import "../components/Table.css";
import moment from "moment/moment";
import companyId from "../config/companyId";
import {
  Calender,
  DropDownUI,
  TextInputForm,
  LoadingSpinner,
} from "../components/Forms";

const EstimationHistory = [
  "S.NO",
  // "Convert",
  "Date",
  "Estimation No.",
  "Name",
  "Amount",
  "Status",
];

const Estimation = () => {
  const location = useLocation();
  const { type, rowData } = location.state || {};

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [openFilter, setFilter] = useState(false);
  const closeFilter = () => setFilter(false);
  const showFilter = () => setFilter(true);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedEstimations, setSelectedEstimations] = useState([]); // Track selected estimations

  const handleClose = () => {
    setShow(false);
    setSelectedOption("");
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const [filterData, setFilterData] = useState({
    search_text: "",
    party_name: "",
    party_id: "",
    from_date: "",
    to_date: "",
  });

  const [dropdownKey, setDropdownKey] = useState(Date.now());

  const clearFilter = () => {
    setFilterData({
      search_text: "",
      party_id: "",
      from_date: "",
      to_date: "",
      bill_no: "",
    });
    setDropdownKey(Date.now());
  };

  const handleClearAll = () => {
    setFilterData({
      search_text: "",
      party_name: "",
      party_id: "",
      from_date: "",
      to_date: "",
      bill_no: "",
    });
    setDropdownKey(Date.now());
    setSelectedEstimations([]);
  };

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setFilterData({
      ...filterData,
      [fieldName]: value,
    });
  };

  const setLabel = (value, field) => {
    const formattedDate = value ? moment(value).format("DD-MM-YYYY") : "";
    setFilterData({
      ...filterData,
      [field]: formattedDate,
    });
  };

  const [partySalesData, setPartySalesData] = useState([]);
  const fetchPartySalesData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/sales_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
          company_id: companyId,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      console.log(responseData);

      if (responseData.code === 200) {
        setPartySalesData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartySalesData();
  }, []);

  const [userData, setUserData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${API_DOMAIN}/sales_estimation.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: filterData.search_text,
            party_name: filterData.party_name,
            party_id: filterData.party_id,
            from_date: filterData.from_date,
            to_date: filterData.to_date,
            bill_no: filterData.bill_no || "",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      console.log(responseData, "siva");

      if (responseData.status === 200) {
        setUserData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filterData]);

  const filteredUserData = userData.filter((item) => {
    const billNo = item.bill_no?.toString() || "";
    const receiptNo = item.receipt_no?.toString() || "";
    const searchText = filterData.search_text?.toString() || "";

    const isSearchMatch =
      searchText === "" ||
      billNo.includes(searchText) ||
      receiptNo.includes(searchText);

    const partyName = item.party_name?.toLowerCase() || "";
    const filterPartyName = filterData.party_name?.toLowerCase() || "";

    const isPartyMatch = partyName.includes(filterPartyName);

    const itemDate = moment(item.bill_date, "DD-MM-YYYY");
    const fromDate = filterData.from_date
      ? moment(filterData.from_date, "YYYY-MM-DD")
      : null;
    const toDate = filterData.to_date
      ? moment(filterData.to_date, "YYYY-MM-DD")
      : null;

    const isDateMatch =
      (!fromDate && !toDate) ||
      (fromDate &&
        toDate &&
        itemDate.isBetween(fromDate, toDate, "day", "[]")) ||
      (fromDate && !toDate && itemDate.isSameOrAfter(fromDate, "day")) ||
      (!fromDate && toDate && itemDate.isSameOrBefore(toDate, "day"));

    return isSearchMatch && isPartyMatch && isDateMatch;
  });

  const openPrintView = async (rowData) => {
    console.log("printrow", rowData);
    const blob = await pdf(<EstimationPdf data={rowData} />).toBlob();
    const url = URL.createObjectURL(blob);
    const printWindow = window.open(url, "_blank");

    if (!printWindow) {
      console.error("Failed to open new tab for PDF");
      return;
    }

    printWindow.onload = () => {
      printWindow.print();
      URL.revokeObjectURL(url);
    };
  };

  const handleEstimationPrintclick = (rowData) => {
    openPrintView(rowData);
  };

  const handleCheckboxChange = (salesEstimationId) => {
    setSelectedEstimations((prev) => {
      if (prev.includes(salesEstimationId)) {
        return prev.filter((id) => id !== salesEstimationId);
      } else {
        return [...prev, salesEstimationId];
      }
    });
  };

  const handleConvertClick = async () => {
    try {
      if (selectedEstimations.length === 0) {
        setShowToast(true);
        return;
      }

      const response = await fetch(
        `${API_DOMAIN}/sales_estimation.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sales_estimation_ids: selectedEstimations,
          }),
        }
      );

      const responseData = await response.json();
      console.log(responseData, "responseData");

      if (responseData.status === 200) {
        setSelectedEstimations([]);
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          window.location.reload();
        }, 2000);
      } else {
        console.error("Conversion failed:", responseData.msg);
        setShowToast(true);
      }
    } catch (error) {
      console.error("Error converting estimations:", error);
      setShowToast(true);
    }
  };

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("Error checking session:", error.message);
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  if (loading) {
    return (
      <LoadingSpinner message="Loading Sales Estimation..." height="300px" />
    );
  }

  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid className="pt-2">
        <div className="main px-2 my-3">
          <div className="mx-2">
            <Navbar>
              <Navbar.Brand>
                <PageTitle PageTitle={"Sale Estimation"} />
              </Navbar.Brand>
              <Nav className="ms-auto">
                <span className="mx-2 py-2">
                  <Buttons lable={<>Filter</>} onClick={showFilter} />
                </span>
                <span className="mx-2 py-2">
                  <Buttons lable={<>Clear</>} onClick={handleClearAll} />
                </span>
                {/* <span className="mx-2 py-2">
                  <Buttons
                    lable={`Selected: ${selectedEstimations.length}`}
                    disabled
                  />
                </span> */}
              </Nav>
            </Navbar>
          </div>
          <Offcanvas show={openFilter} onHide={closeFilter} placement="end">
            <Offcanvas.Body>
              <Row>
                <Col lg="6">
                  <PageTitle PageTitle={<>Sales Estimation</>} />
                </Col>
                <Col lg="6" className="align-self-center">
                  <div className="text-end">
                    <Buttons
                      onClick={closeFilter}
                      lable={
                        <>
                          <MdOutlineClose />
                        </>
                      }
                    ></Buttons>
                  </div>
                </Col>
              </Row>
              <div>
                <div className="py-3">
                  <TextInputForm
                    labelname={"Search Receipt"}
                    placeholder={"Search Receipt"}
                    name="search_text"
                    value={filterData.search_text}
                    onChange={(e) => handleChange(e, "search_text")}
                  ></TextInputForm>
                </div>
                <div className="py-3">
                  <TextInputForm
                    placeholder={"Party Name"}
                    labelname={"Party Name"}
                    name="party_name"
                    value={filterData.party_name}
                    onChange={(e) => handleChange(e, "party_name")}
                  />
                </div>
                <Row>
                  <Col lg="6" className="align-self-center">
                    <div>
                      <Calender
                        key={dropdownKey}
                        setLabel={(date) => setLabel(date, "from_date")}
                        selectedDate={filterData.from_date}
                        calenderlabel="From Date"
                      />
                    </div>
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div>
                      <Calender
                        key={dropdownKey}
                        setLabel={(date) => setLabel(date, "to_date")}
                        selectedDate={filterData.to_date}
                        calenderlabel="To Date"
                      />
                    </div>
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div className="my-5 text-center">
                      <Buttons
                        lable={"Apply"}
                        onClick={() => {
                          closeFilter();
                        }}
                      ></Buttons>
                    </div>
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div className="my-5 text-center">
                      <Buttons lable={"Clear"} onClick={clearFilter}></Buttons>
                    </div>
                  </Col>
                </Row>
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
        <div className="main p-3">
          <div className="py-1 mx-2">
            <Navbar>
              <Container fluid className="px-0">
                <Navbar.Brand>
                  <PageTitle PageTitle={"Transactions"} />
                </Navbar.Brand>
                <Nav className="ms-auto">
                  <span className="mx-2 py-2">
                    <Buttons
                      lable={<>Add New</>}
                      onClick={() =>
                        navigate("/console/sales/estimation/create")
                      }
                    />
                  </span>
                  {selectedEstimations.length > 0 && (
                    <span className="mx-2 py-2">
                      <Buttons
                        lable={<>Submit</>}
                        onClick={() => setShowConfirm(true)}
                      />
                    </span>
                  )}
                </Nav>
              </Container>
            </Navbar>
          </div>
          <div className="py-2 c-table table-scroll mx-2">
            <TableUI
              headers={EstimationHistory}
              body={filteredUserData}
              type="salesestimation"
              handleEditClick={handleEstimationPrintclick}
              pageview={"yes"}
              onDelete={fetchData}
              handleCheckboxChange={handleCheckboxChange}
              selectedEstimations={selectedEstimations}
            ></TableUI>
          </div>
        </div>

        <Modal
          size="sm"
          show={showConfirm}
          onHide={() => setShowConfirm(false)}
          centered
          className="py-5"
        >
          <Modal.Body>Are you sure you want to convert to invoice?</Modal.Body>
          <Modal.Footer className="justify-content-center border-top-0">
            <ClickButton
              variant="secondary"
              label={<>Yes</>}
              onClick={async () => {
                setShowConfirm(false);
                await handleConvertClick();
              }}
            />
            <ClickButton
              variant="primary"
              label={<>No</>}
              onClick={() => {
                setShowConfirm(false);
              }}
            />
          </Modal.Footer>
        </Modal>

        {showToast && (
          <ToastContainer position="top-end" className="p-3">
            <Toast
              onClose={() => setShowToast(false)}
              show={showToast}
              delay={2000}
              autohide
              bg="success"
            >
              <Toast.Body className="text-white">
                Successfully converted!
              </Toast.Body>
            </Toast>
          </ToastContainer>
        )}
      </Container>
    </div>
  );
};

export default Estimation;
